@if (isMobile()) {
  <button
    type="button"
    class="mobileMenuButton"
    (click)="toggleMobileSidebar()"
    aria-label="Open navigation"
  >
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        d="M4 7h16M4 12h16M4 17h16"
        fill="none"
        stroke="currentColor"
        stroke-width="2.2"
        stroke-linecap="round"
      />
    </svg>
  </button>

  @if (isMobileSidebarOpen()) {
    <button
      type="button"
      class="mobileSidebarBackdrop"
      (click)="closeMobileSidebar()"
      aria-label="Close navigation"
    ></button>
  }
}

<div class="layout" [class.sidebarCollapsed]="isSidebarCollapsed() && !isMobile()">
  <app-sidebar
    [collapsed]="isSidebarCollapsed()"
    [isMobile]="isMobile()"
    [isMobileOpen]="isMobileSidebarOpen()"
    (toggleCollapse)="toggleSidebar()"
    (closeMobile)="closeMobileSidebar()"
  />

  <main class="content">
    <div class="contentScroll" #contentScroll>
      <router-outlet />
    </div>
  </main>
</div>
